@import "../../variables.scss";
$border-radius: 5px;
$transition-speed: 0.2s;

.optionsGroup {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.optionContainer {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: $border-radius;
  cursor: pointer;
  transition: border-color $transition-speed ease-in-out, background-color $transition-speed ease-in-out;

  &__selected {
    border-color: $color-bright-blue;
    background-color: $color-light-blue;
  }

  input {
    display: none;
  }

  &__customOption {
    display: inline-block;
    min-width: 20px;
    width: 20px;
    height: 20px;
    border: 1px solid $color-black;
    border-radius: 50%;
    margin-right: 10px;
    position: relative;
    flex-shrink: 0;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 12px;
      height: 12px;
      background-color: $color-bright-blue;
      border-radius: 50%;
      opacity: 0;
      transition: opacity $transition-speed ease-in-out;
    }
  }

  input:checked + &__customOption {
    border: 2px solid $color-mid-blue;
  }

  input:checked + &__customOption::after {
    opacity: 1;
  }

  .labelText {
    flex: 1;
    word-break: break-word;
  }
}
